import { useQuery } from '@tanstack/react-query';
import { EmployeeDictionaryType } from '../../models/employeeHub';
import { employeeDictionaryService } from '../../features/employee-hub/services/employeeDictionaryService';

export const employeeDictionaryQueryKey = (type: EmployeeDictionaryType) =>
    ['employee-dictionary', type] as const;

export const useEmployeeDictionary = (type: EmployeeDictionaryType) =>
    useQuery({
        queryKey: employeeDictionaryQueryKey(type),
        queryFn: () => employeeDictionaryService.getAll(type),
        staleTime: 5 * 60 * 1000, // 5 minutes - dictionary data changes rarely
    });
